"use client";

import { IconCircle } from "@/components/icon/circle";
import { QuestionForm } from "./form";
import { Mail, MapPin, PhoneCall } from "lucide-react";

interface AddQuestionProps {
  image_url: string;
  contact_address: string;
  contact_phone: string;
  contact_email: string
}

export function AddQuestion({
  image_url,
  contact_address,
  contact_phone,
  contact_email
}: Readonly<AddQuestionProps>) {
  return (
    <div
      className="relative flex flex-col w-full lg:flex-row items-center justify-center gap-6 p-2 md:p-16"
      style={{
        backgroundImage: `url(${image_url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="absolute inset-0 bg-black/40 rounded-xl md:rounded-2xl" />

      <div className="relative w-full lg:w-1/2 z-10">
        <div
          className="
            rounded-2xl shadow-md
            bg-white/30 
            backdrop-blur-lg
            md:p-8 p-4
          "
        >
          <QuestionForm />
        </div>
      </div>

      <div className="relative w-full lg:w-1/2  lg:flex flex-col items-center text-center md:text-right justify-center p-6 z-10">
        <p className="text-white text-4xl font-bold mb-6 leading-relaxed">
          آماده پاسخگویی به سوالات و نیازهای شما هستیم.
        </p>

        <div className="flex flex-col gap-4 sm:gap-6 text-sm sm:text-base mt-12">
          {contact_phone && (
            <div className="flex items-center gap-3">
              <IconCircle className="w-14 h-14  flex items-center justify-center rounded-full border border-white/40 backdrop-blur-[20px] bg-primary">
                <PhoneCall className="w-7 h-7  rotate-250 text-white" />
              </IconCircle>
              <span className="sm:text-lg text-white">{contact_phone}</span>
            </div>
          )}
          {contact_email && (
            <div className="flex items-center gap-3">
              <IconCircle className="w-14 h-14  flex items-center justify-center rounded-full border border-white/40 backdrop-blur-[20px] bg-primary">
                <Mail className="w-7 h-7 text-white" />
              </IconCircle>
              <span className="sm:text-lg text-white">{contact_email}</span>
            </div>
          )}
          {contact_address && (
            <div className="flex items-center gap-3">
              <IconCircle className="w-14 h-14  flex items-center justify-center rounded-full border border-white/40 backdrop-blur-[20px] bg-primary">
                <MapPin className="w-7 h-7 text-white" />
              </IconCircle>
              <span className="sm:text-lg text-white text-right md:text-center">{contact_address}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
